module.exports = __webpack_public_path__ + "img/bktj.e1518110.png";